/**
 * Aroma Avenue cart drawer:
 * gift sync + scent property, add-on suggestion, 50→100 upgrade,
 * checkout gate, progress animation, upsells.
 */
(function () {
  if (window.__aaCartDrawerInit) return;
  window.__aaCartDrawerInit = true;

  var giftSyncing = false;

  function rootPath() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function money(cents) {
    var format =
      (window.themeVariables &&
        themeVariables.settings &&
        (themeVariables.settings.currencyCodeEnabled
          ? themeVariables.settings.moneyWithCurrencyFormat
          : themeVariables.settings.moneyFormat)) ||
      '£{{amount}}';
    var amount = (Math.max(0, Math.round(cents)) / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_currency\s*\}\}/g, amount);
  }

  function configFromDrawer() {
    var el = document.getElementById('aa-cart-drawer-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function isGiftItem(item, cfg) {
    if (!item) return false;
    var props = item.properties || {};
    if (props._aa_free_gift === 'true' || props._aa_free_gift === true) return true;
    if (cfg && cfg.giftProductId && item.product_id === cfg.giftProductId) return true;
    return false;
  }

  function findGiftLine(cart, cfg) {
    return (cart.items || []).find(function (item) {
      return isGiftItem(item, cfg);
    });
  }

  function subtotalExGift(cart, cfg) {
    return (cart.items || []).reduce(function (sum, item) {
      if (isGiftItem(item, cfg)) return sum;
      return sum + (item.final_line_price || item.line_price || 0);
    }, 0);
  }

  async function fetchCart() {
    return (await fetch(rootPath() + 'cart.js', { credentials: 'same-origin' })).json();
  }

  async function bundleSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections },
      })
    );
    return sections;
  }

  async function dispatchCartChange(cart, baseEvent) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: baseEvent || 'aa-cart', cart: cart },
      })
    );
  }

  function animateProgress() {
    var fill = document.querySelector('#cart-drawer [data-aa-rewards-fill]');
    if (!fill) return;
    var target = fill.getAttribute('data-width') || '0';
    requestAnimationFrame(function () {
      fill.style.width = target + '%';
    });
  }

  function renderAddonSuggestion() {
    var slot = document.querySelector('#cart-drawer [data-aa-addon-slot]');
    var cfg = configFromDrawer();
    if (!slot || !cfg) return;

    slot.hidden = true;
    slot.innerHTML = '';

    if (!cfg.showProgressBar) return;
    if (cfg.nextTier === 'done' || cfg.gapCents <= 0) return;

    var gap = cfg.gapCents;
    var cartHandles = cfg.cartHandles || [];
    var best = null;

    (cfg.addonCandidates || []).forEach(function (cand) {
      if (!cand || !cand.variantId) return;
      if (cand.handle && cartHandles.indexOf(cand.handle) !== -1 && cand.type === 'bottle') return;
      var maxQ = cand.maxQty || 1;
      for (var q = 1; q <= maxQ; q++) {
        var cost = cand.unitPrice * q;
        if (cost < gap) continue;
        var waxish =
          !!cand.isWax ||
          /wax|melt/i.test(cand.name || '') ||
          /wax|melt/i.test(cand.handle || '');
        if (
          !best ||
          cost < best.cost ||
          (cost === best.cost && waxish && !best.isWax)
        ) {
          best = {
            type: cand.type,
            size: cand.size || '',
            name: cand.name,
            handle: cand.handle || '',
            variantId: cand.variantId,
            qty: q,
            cost: cost,
            unitPrice: cand.unitPrice,
            isWax: waxish,
          };
        }
      }
    });

    if (!best) return;

    var forWhat = cfg.nextTier === 'gift' ? 'a free 10ml' : 'free delivery';
    var label;
    var hay = ((best.handle || '') + ' ' + (best.name || '')).toLowerCase();
    var isWax =
      !!best.isWax ||
      best.type === 'addon' && (/wax/.test(hay) || /melt/.test(hay));
    var isCandle = best.type === 'addon' && /candle/.test(hay) && !isWax;

    if (isWax) {
      best.isWax = true;
      if (best.qty > 1) {
        label = 'Add ' + best.qty + ' wax melts for ' + money(best.cost) + ' for ' + forWhat;
      } else {
        label = 'Add a wax melt for ' + money(best.cost) + ' for ' + forWhat;
      }
    } else if (isCandle) {
      label = 'Add a candle for ' + money(best.cost) + ' for ' + forWhat;
    } else if (best.type === 'bottle') {
      label = 'Add a ' + best.size + ' scent (' + money(best.cost) + ') for ' + forWhat;
    } else if (best.type === 'addon') {
      // Unknown add-on from the cart-add-ons collection — never use a scent-only name
      label = 'Add an add-on for ' + money(best.cost) + ' for ' + forWhat;
    } else {
      label = 'Add ' + best.name + ' (' + money(best.cost) + ') for ' + forWhat;
    }

    var html = '<div class="aa-cart-addon__card">';
    html += '<p class="aa-cart-addon__text" data-aa-addon-label>' + label + '</p>';

    if (best.type === 'bottle' && !best.isWax) {
      var scents = (cfg.giftScents || []).filter(function (s) {
        return cartHandles.indexOf(s.handle) === -1;
      });
      var bottleOpts = (cfg.addonCandidates || []).filter(function (c) {
        return c.type === 'bottle' && c.size === best.size && cartHandles.indexOf(c.handle) === -1;
      });
      var ordered = [];
      scents.forEach(function (s) {
        var match = bottleOpts.find(function (b) {
          return b.handle === s.handle;
        });
        if (match) ordered.push(match);
      });
      bottleOpts.forEach(function (b) {
        if (
          !ordered.find(function (o) {
            return o.handle === b.handle;
          })
        )
          ordered.push(b);
      });

      if (!ordered.length) return;

      // Align headline price with the first (selected) option
      var first = ordered[0];
      label = 'Add a ' + best.size + ' scent (' + money(first.unitPrice) + ') for ' + forWhat;
      html = '<div class="aa-cart-addon__card"><p class="aa-cart-addon__text" data-aa-addon-label>' + label + '</p>';

      html +=
        '<div class="aa-cart-addon__row">' +
        '<label class="sr-only" for="aa-addon-scent">Choose scent</label>' +
        '<select id="aa-addon-scent" class="aa-cart-addon__select" data-aa-addon-scent data-aa-addon-for="' +
        forWhat.replace(/"/g, '') +
        '" data-aa-addon-size="' +
        best.size +
        '">';
      ordered.forEach(function (b, i) {
        html +=
          '<option value="' +
          b.variantId +
          '" data-price="' +
          b.unitPrice +
          '" data-name="' +
          String(b.name).replace(/"/g, '&quot;') +
          '"' +
          (i === 0 ? ' selected' : '') +
          '>' +
          b.name +
          ' — ' +
          money(b.unitPrice) +
          '</option>';
      });
      html +=
        '</select>' +
        '<button type="button" class="aa-cart-addon__btn" data-aa-addon-add data-qty="1">Add</button>' +
        '</div>';
    } else {
      html +=
        '<button type="button" class="aa-cart-addon__btn" data-aa-addon-add data-variant-id="' +
        best.variantId +
        '" data-qty="' +
        best.qty +
        '">Add</button>';
    }

    html += '</div>';
    slot.innerHTML = html;
    slot.hidden = false;
  }

  async function syncGift(cart) {
    var cfg = configFromDrawer();
    if (!cfg || !cfg.giftEnabled || !cfg.giftVariantId || !cfg.giftThreshold) return cart;
    if (giftSyncing) return cart;

    var sub = subtotalExGift(cart, cfg);
    var giftLine = findGiftLine(cart, cfg);
    var shouldHave = sub >= cfg.giftThreshold;

    if (shouldHave && !giftLine) {
      giftSyncing = true;
      try {
        var sections = await bundleSections();
        var addRes = await fetch(rootPath() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [
              {
                id: cfg.giftVariantId,
                quantity: 1,
                properties: { _aa_free_gift: 'true', Scent: '' },
              },
            ],
            sections: sections,
            sections_url: rootPath(),
          }),
        });
        if (!addRes.ok) return cart;
        var addJson = await addRes.json();
        var nextCart = await fetchCart();
        if (addJson.sections) nextCart.sections = addJson.sections;
        await dispatchCartChange(nextCart, 'aa-gift-add');
        return nextCart;
      } catch (e) {
        console.warn('[aa-cart] gift add failed', e);
        return cart;
      } finally {
        giftSyncing = false;
      }
    }

    if (!shouldHave && giftLine) {
      giftSyncing = true;
      try {
        var sections2 = await bundleSections();
        var changeRes = await fetch(rootPath() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: giftLine.key, quantity: 0, sections: sections2 }),
        });
        if (!changeRes.ok) return cart;
        var nextCart2 = await changeRes.json();
        await dispatchCartChange(nextCart2, 'aa-gift-remove');
        return nextCart2;
      } catch (e) {
        console.warn('[aa-cart] gift remove failed', e);
        return cart;
      } finally {
        giftSyncing = false;
      }
    }

    // Ensure gift qty never exceeds 1
    if (giftLine && giftLine.quantity > 1) {
      giftSyncing = true;
      try {
        var sections3 = await bundleSections();
        var fixRes = await fetch(rootPath() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: giftLine.key, quantity: 1, sections: sections3 }),
        });
        if (fixRes.ok) {
          var fixed = await fixRes.json();
          await dispatchCartChange(fixed, 'aa-gift-fix-qty');
          return fixed;
        }
      } catch (e) {
        /* ignore */
      } finally {
        giftSyncing = false;
      }
    }

    return cart;
  }

  async function addToCart(items) {
    var sections = await bundleSections();
    var res = await fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items, sections: sections, sections_url: rootPath() }),
    });
    if (!res.ok) throw new Error('add failed');
    var addJson = await res.json();
    var cart = await fetchCart();
    if (addJson.sections) cart.sections = addJson.sections;
    document.documentElement.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: addJson.items || [addJson], cart: cart },
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: cart },
      })
    );
    return cart;
  }

  async function changeLine(payload) {
    var sections = await bundleSections();
    payload.sections = sections;
    var res = await fetch(rootPath() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error('change failed');
    var cart = await res.json();
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'aa-line-change', cart: cart },
      })
    );
    return cart;
  }

  function giftScentSelected() {
    var select = document.querySelector('#cart-drawer [data-aa-gift-scent]');
    if (!select) return true; // no gift line
    return !!(select.value && select.value.trim());
  }

  function showGiftError(show) {
    var el = document.querySelector('#cart-drawer [data-aa-gift-error]');
    if (!el) return;
    el.hidden = !show;
  }

  document.addEventListener(
    'click',
    function (event) {
      var upsellBtn = event.target.closest('[data-aa-upsell-add]');
      if (upsellBtn) {
        event.preventDefault();
        var id = upsellBtn.getAttribute('data-aa-upsell-add');
        upsellBtn.setAttribute('aria-busy', 'true');
        upsellBtn.disabled = true;
        addToCart([{ id: Number(id), quantity: 1 }]).catch(function () {
          upsellBtn.disabled = false;
          upsellBtn.removeAttribute('aria-busy');
        });
        return;
      }

      var addonBtn = event.target.closest('[data-aa-addon-add]');
      if (addonBtn) {
        event.preventDefault();
        var qty = parseInt(addonBtn.getAttribute('data-qty') || '1', 10) || 1;
        var variantId = addonBtn.getAttribute('data-variant-id');
        if (!variantId) {
          var sel = document.querySelector('#cart-drawer [data-aa-addon-scent]');
          variantId = sel && sel.value;
        }
        if (!variantId) return;
        addonBtn.setAttribute('aria-busy', 'true');
        addonBtn.disabled = true;
        addToCart([{ id: Number(variantId), quantity: qty }]).catch(function () {
          addonBtn.disabled = false;
          addonBtn.removeAttribute('aria-busy');
        });
        return;
      }

      var upgradeBtn = event.target.closest('[data-aa-upgrade]');
      if (upgradeBtn) {
        event.preventDefault();
        var lineKey = upgradeBtn.getAttribute('data-line-key');
        var variantId2 = upgradeBtn.getAttribute('data-variant-id');
        var quantity = parseInt(upgradeBtn.getAttribute('data-quantity') || '1', 10) || 1;
        upgradeBtn.setAttribute('aria-busy', 'true');
        changeLine({ id: lineKey, quantity: quantity, properties: undefined }).catch(function () {});
        // Shopify cart/change can't swap variant via id key alone when changing variant —
        // use cart/change with line key removed + add new, or updates with variant id:
        // Official: POST { id: line_key, quantity, ... } keeps same variant.
        // To change variant: remove line and add new variant, or use:
        // { 'line': n, 'id': newVariantId, 'quantity': q }
        (async function () {
          try {
            // Find line index
            var cart = await fetchCart();
            var idx = (cart.items || []).findIndex(function (it) {
              return it.key === lineKey;
            });
            if (idx < 0) return;
            var sections = await bundleSections();
            var res = await fetch(rootPath() + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({
                line: idx + 1,
                id: Number(variantId2),
                quantity: quantity,
                sections: sections,
              }),
            });
            if (!res.ok) throw new Error('upgrade failed');
            var next = await res.json();
            await dispatchCartChange(next, 'aa-upgrade');
          } catch (e) {
            console.warn('[aa-cart] upgrade failed', e);
            upgradeBtn.removeAttribute('aria-busy');
          }
        })();
        return;
      }

      var dec = event.target.closest('[data-aa-qty-dec]');
      var inc = event.target.closest('[data-aa-qty-inc]');
      if (!dec && !inc) return;
      var wrap = event.target.closest('line-item-quantity');
      if (!wrap || !wrap.closest('#cart-drawer')) return;
      event.preventDefault();
      var input = wrap.querySelector('.quantity-input');
      if (!input) return;
      var step = parseInt(input.step || '1', 10) || 1;
      var min = parseInt(input.min || '0', 10);
      var max = input.max !== '' ? parseInt(input.max, 10) : null;
      var val = parseInt(input.value || '0', 10) || 0;
      val = dec ? val - step : val + step;
      if (val < min) val = min;
      if (max != null && !isNaN(max) && val > max) val = max;
      input.value = String(val);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    },
    true
  );

  document.addEventListener('change', function (event) {
    var addonSelect = event.target.closest('[data-aa-addon-scent]');
    if (addonSelect && addonSelect.closest('#cart-drawer')) {
      var opt = addonSelect.options[addonSelect.selectedIndex];
      var labelEl = document.querySelector('#cart-drawer [data-aa-addon-label]');
      if (opt && labelEl) {
        var price = Number(opt.getAttribute('data-price') || 0);
        var size = addonSelect.getAttribute('data-aa-addon-size') || '50ml';
        var forWhat = addonSelect.getAttribute('data-aa-addon-for') || 'free delivery';
        labelEl.textContent = 'Add a ' + size + ' scent (' + money(price) + ') for ' + forWhat;
      }
      return;
    }

    var scentSelect = event.target.closest('[data-aa-gift-scent]');
    if (!scentSelect || !scentSelect.closest('#cart-drawer')) return;
    var lineKey = scentSelect.getAttribute('data-line-key');
    var scent = scentSelect.value || '';
    showGiftError(false);
    changeLine({
      id: lineKey,
      quantity: 1,
      properties: { _aa_free_gift: 'true', Scent: scent },
    }).catch(function (e) {
      console.warn('[aa-cart] scent save failed', e);
    });
  });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('[data-aa-checkout-form]');
      if (!form || !form.closest('#cart-drawer')) return;
      if (!giftScentSelected()) {
        event.preventDefault();
        showGiftError(true);
        var sel = document.querySelector('#cart-drawer [data-aa-gift-scent]');
        if (sel) sel.focus();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var checkout = event.target.closest('[data-aa-checkout]');
      if (!checkout || !checkout.closest('#cart-drawer')) return;
      if (!giftScentSelected()) {
        event.preventDefault();
        showGiftError(true);
        var sel = document.querySelector('#cart-drawer [data-aa-gift-scent]');
        if (sel) sel.focus();
      }
    },
    true
  );

  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    var base = event.detail && event.detail.baseEvent;
    if (!cart) return;
    if (base === 'aa-gift-add' || base === 'aa-gift-remove' || base === 'aa-gift-fix-qty') {
      setTimeout(function () {
        animateProgress();
        renderAddonSuggestion();
      }, 50);
      return;
    }
    setTimeout(
      function () {
        animateProgress();
        renderAddonSuggestion();
        syncGift(cart);
      },
      base === 'variant:add' || base === 'aa-upgrade' || base === 'aa-line-change' ? 80 : 1300
    );
  });

  document.addEventListener('dialog:after-show', function (event) {
    if (event.target && event.target.id === 'cart-drawer') {
      document.documentElement.classList.add('aa-cart-open');
      animateProgress();
      renderAddonSuggestion();
    }
  });

  document.addEventListener('dialog:after-hide', function (event) {
    if (event.target && event.target.id === 'cart-drawer') {
      document.documentElement.classList.remove('aa-cart-open');
    }
  });

  document.addEventListener(
    'toggle',
    function (event) {
      if (event.target && event.target.id === 'cart-drawer') {
        document.documentElement.classList.toggle('aa-cart-open', event.target.hasAttribute('open'));
      }
    },
    true
  );

  // PDP 50ml → 100ml upgrade line
  function updatePdpUpgrade() {
    document.querySelectorAll('[data-aa-pdp-upgrade]').forEach(function (el) {
      var v50 = Number(el.getAttribute('data-price-50') || 0);
      var v100 = Number(el.getAttribute('data-price-100') || 0);
      var available100 = el.getAttribute('data-available-100') === 'true';
      var selected = el.getAttribute('data-selected-size') || '';
      var diff = v100 - v50;
      if (!available100 || selected !== '50ml' || diff <= 0) {
        el.hidden = true;
        return;
      }
      el.hidden = false;
      var amount = el.querySelector('[data-aa-pdp-upgrade-amount]');
      if (amount) amount.textContent = money(diff);
    });
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    document.querySelectorAll('[data-aa-pdp-upgrade]').forEach(function (el) {
      var opts = variant.options || [];
      var size = '';
      opts.forEach(function (o) {
        var v = String(o).toLowerCase();
        if (v === '50ml' || v === '100ml') size = v;
      });
      if (!size && variant.title) {
        var t = String(variant.title).toLowerCase();
        if (t.indexOf('50ml') >= 0) size = '50ml';
        if (t.indexOf('100ml') >= 0) size = '100ml';
      }
      el.setAttribute('data-selected-size', size);
    });
    updatePdpUpgrade();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      animateProgress();
      renderAddonSuggestion();
      updatePdpUpgrade();
    });
  } else {
    animateProgress();
    renderAddonSuggestion();
    updatePdpUpgrade();
  }
})();
